/* BEGIN SEO-SAFE infinite scroll (usa #product-grid) ESTE CODIGO ES CUSTOM*/
(function () {
  const grid = document.getElementById('product-grid');
  const loadMore = document.getElementById('LoadMoreLink');
  if (!grid || !loadMore) return;

  // Marcamos que el script está activo (no dependemos de .js del theme)
  document.documentElement.classList.add('has-infinite-scroll');

  let isLoading = false;
  let lastCommittedPage = Number(loadMore.dataset.page) - 1 || 1;

  // Mejora progresiva: si no hay JS, el enlace funciona normal
  loadMore.addEventListener('click', function (ev) {
    ev.preventDefault();
    const nextUrl = loadMore.getAttribute('data-next') || loadMore.getAttribute('href');
    if (!nextUrl || isLoading) return;
    fetchNext(nextUrl);
  });

  // Autocarga al acercarse al botón
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        const nextUrl = loadMore.getAttribute('data-next') || loadMore.getAttribute('href');
        if (nextUrl && !isLoading) fetchNext(nextUrl);
      }
    });
  }, { rootMargin: '600px 0px' });
  io.observe(loadMore);

  async function fetchNext(url) {
    try {
      isLoading = true;
      loadMore.setAttribute('aria-busy', 'true');

      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();

      // Parsear siguiente página
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('#product-grid');
      const newItems = newGrid ? Array.from(newGrid.children) : [];
      newItems.forEach((el) => grid.appendChild(el));

      // Determinar la página que acabamos de añadir
      const appendedPage = getParam('page', url) || (lastCommittedPage + 1);

      // Buscar el siguiente LoadMore en la página siguiente
      const nextLink = doc.querySelector('#LoadMoreLink');
      if (nextLink) {
        const nextHref = nextLink.getAttribute('data-next') || nextLink.getAttribute('href');
        const nextPage = Number(nextLink.dataset.page) || (getParam('page', nextHref) || (appendedPage + 1));
        loadMore.setAttribute('data-next', nextHref);
        loadMore.setAttribute('href', nextHref);
        loadMore.setAttribute('data-page', String(nextPage));
      } else {
        // Ya no hay más páginas
        io.disconnect();
        loadMore.remove();
      }

      // Actualiza URL y meta si realmente avanzamos
      if (appendedPage > lastCommittedPage) {
        const newUrl = updateQueryParam(window.location.href, 'page', appendedPage);
        history.pushState({ page: appendedPage }, '', newUrl);
        lastCommittedPage = appendedPage;

        // Actualizar <title> si existe
        const newTitle = doc.querySelector('title')?.textContent?.trim();
        if (newTitle) document.title = newTitle;

        // Actualizar meta description si existe
        const newDesc = doc.querySelector('meta[name="description"]')?.getAttribute('content');
        if (newDesc) {
          let meta = document.querySelector('meta[name="description"]');
          if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'description');
            document.head.appendChild(meta);
          }
          meta.setAttribute('content', newDesc);
        }
      }
    } catch (e) {
      console.error('[infinite-scroll]', e);
      // Si falla, el enlace sigue funcionando como enlace normal
    } finally {
      isLoading = false;
      loadMore.removeAttribute('aria-busy');
    }
  }

  function getParam(name, url) {
    try {
      const u = new URL(url, window.location.origin);
      return Number(u.searchParams.get(name));
    } catch {
      return null;
    }
  }

  function updateQueryParam(url, key, val) {
    const u = new URL(url, window.location.origin);
    if (val === 1 || val == null) {
      u.searchParams.delete(key); // página 1 sin querystring
    } else {
      u.searchParams.set(key, String(val));
    }
    return u.pathname + u.search + u.hash;
  }
})();
